/**
 *	 modal
 *	 default : デフォルトのmodal（黒背景）
 *	 white : 右から出るmodal
*/
import utils from './utils.js';

export default class {

	constructor(e, addclose) {
		this.type = $(e).hasClass('js-modal__button') ? 'default' : 'white';
		this.$el = $(e).hasClass('js-modal__button') ? $('#js-modal') : $('#js-modal--white');
		this.$body = $(e).hasClass('js-modal__button') ? $('#js-modal__body') : $('#js-modal--white__body');
		this.href = $(e).data('href');
		this.util = new utils();
//		this.$image = null;
		this.transition = [
			"webkitTransitionEnd.modal",
			"mozTransitionEnd.modal",
			"oTransitionEnd.modal",
			"transitionend.modal"
		].join(' ');

		if(!addclose) {
			this.$el.removeClass('is-show');
			$(e).off('click.modal');
			$(e).on('click.modal', this.modalToggle.bind(this));
		}

		// modal外エリアで閉じる
		this.$el.find('.js-modal__button,.js-modal--white__button').off('click.modal');
		this.$el.find('.js-modal__button,.js-modal--white__button').on('click.modal', this.modalToggle.bind(this));
	}

	modalToggle(ev) {
		if(this.type == 'default') {
			this.toggleDefault();
		} else {
			this.toggleWhite();
		}
		ev.stopPropagation();
		return false;
	}

	toggleDefault() {
		// close
		if(this.$el.hasClass('is-show')) {
			this.$el.removeClass('is-show');

			// transition終わりにコンテンツhidden
			this.$el.on(this.transition, function(ev, el) {
				this.$el.off(this.transition);
				this.$el.removeClass('is-animated');
				this.$body.html('');
			}.bind(this));

/* あとで使うかも
			// e001-2内のサムネイルを削除（input type="file"の中身も削除）
			if (btn.classList.contains('js-modal__button--remove') && currentmodal.$image) {
				currentmodal.$image.getElementsByTagName('img')[0].setAttribute('src', '');
				currentmodal.$image.classList.add('d-none');
				currentmodal.$image.previousElementSibling.classList.remove('d-none');
				currentmodal.$image.previousElementSibling.getElementsByClassName('.js-choice-list-image').val = '';
				currentmodal.$image = null;
			}
*/
			return false;
		}

		// open
		this.$el.removeClass('is-fixed');

		this.$el.addClass('is-show');
		this.$el.addClass('is-animated');

		if(this.href) this.modalData();

		// e001-2内のサムネイルを内包するDOMを取得
//		if(btn.classList.contains('c-list-drag__image-upload')) currentmodal.$image = btn;
	}

	toggleWhite() {
		// close
		if(this.$el.hasClass('is-show')) {
			this.$el.removeClass('is-show');

			$("body").removeClass('u-ov--hidden');

			this.$el.find('.select2-container').remove(); // select2

			// transition終わりにコンテンツhidden
			this.$el.on(this.transition, function(ev, el) {
				this.$el.off(this.transition);
				this.$el.removeClass('is-animated');
				this.$body.html('');
			}.bind(this));

			return false;
		}

		// open
		$("body").addClass('u-ov--hidden');

		this.$el.addClass('is-show');
		this.$el.addClass('is-animated');

		if(this.href) this.modalData();
	}

	contentsHeight() {
		this.$el.removeClass('is-fixed');
		let h = $('.c-modal__body__inner').length ? document.querySelector('.c-modal__body__inner').scrollHeight : 0;
		if(h > window.innerHeight - 40) this.$el.addClass('is-fixed');
	}

	modalData() {
		this.util.checkSession();

		$.ajax({
			type: "GET",
			url: this.href,
			dataType: 'html'
		}).done(function(data) {
			var doc = $(data);
			this.$body.html(doc);

			doc.ready(function() {
				// 閉じるイベントつける
				this.$el.find('.js-modal__button,.js-modal--white__button').off('click.modal');
				this.$el.find('.js-modal__button,.js-modal--white__button').on('click.modal', this.modalToggle.bind(this));

				if(this.type == 'default') this.contentsHeight(); // default

				// White::モーダル下部のナビゲーションが存在したら中身の高さ変更
				if($('.c-modal__nav').length) this.$el.addClass('is-has-nav');
			}.bind(this));

		}.bind(this)).fail(function(jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外

			if(this.type == 'default') this.contentsHeight(); // default

			this.util.checkSession(jqXHR);
		}.bind(this));
	}
}
